import { Component, Input } from '@angular/core';

@Component({
  selector: 'mprd-address',
  templateUrl: './address.component.html',
})
export class AddressComponent {
  @Input() public address: any;
  @Input() public showInOneLine: boolean;
  @Input() public showCountry: boolean;
  @Input() public otherClass: string;
}
